import shop from '../../api/shop'

const state = () => ({
  all: []
});

const getters = {
  allPayments: state => state.all
};

const actions = {
  getAllPayments ({ commit }) {
    shop.getPayments(cb => {
      commit('setPayments', cb)
    })
  },
};

const mutations = {
  setPayments: (state, payments) => (state.all = payments),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/payments.js